module.exports = __webpack_public_path__ + "assets/img/Coolabah-Turf-Article-w540.64f8ee61.jpg";